/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The type of identification document.
 */
export type MaskedCardholderInfoDocumentType = typeof MaskedCardholderInfoDocumentType[keyof typeof MaskedCardholderInfoDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaskedCardholderInfoDocumentType = {
  passport: 'passport',
  'drivers-license': 'drivers-license',
  'national-id': 'national-id',
} as const;
